import React, { createContext, ReactNode, useContext, useRef } from 'react';

import { useCognitoAuth } from './cognito';
import type { AuthState } from './types';
export type { AuthState } from './types';

export const AuthContext = createContext<AuthState | undefined>(undefined);

export interface AuthProviderProps {
	children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
	const auth = useCognitoAuth();
	return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
	const ctx = useContext(AuthContext);
	if (!ctx) throw new Error('useAuth must be used within an auth provider');
	return ctx;
};
